import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-video.tsx
/**
* icon.24.video
*
* Keywords: play, media, triangle, right, start, rounded-square, control, frame
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOCA3aDhhMSAxIDAgMCAxIDEgMXY4YTEgMSAwIDAgMS0xIDFIOGExIDEgMCAwIDEtMS0xVjhhMSAxIDAgMCAxIDEtMU02IDhhMiAyIDAgMCAxIDItMmg4YTIgMiAwIDAgMSAyIDJ2OGEyIDIgMCAwIDEtMiAySDhhMiAyIDAgMCAxLTItMnptNC45OTYgMS4xMzJBMSAxIDAgMCAwIDkuNSAxMHY0YTEgMSAwIDAgMCAxLjQ5Ni44NjhsMy41LTJhMSAxIDAgMCAwIDAtMS43MzZ6bS41MDQgNC4yOTctMSAuNTcxdi00bDEgLjU3MSAxLjQ5Mi44NTNMMTQgMTJsLTEuMDA4LjU3NnoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9452
*/
const Icon24Video = memo(function Icon24Video(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M8 7h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1M6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm4.996 1.132A1 1 0 0 0 9.5 10v4a1 1 0 0 0 1.496.868l3.5-2a1 1 0 0 0 0-1.736zm.504 4.297-1 .571v-4l1 .571 1.492.853L14 12l-1.008.576z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Video };

//# sourceMappingURL=icon-24-video.js.map